import { TRUST_BAR } from "@/constants/testIds";

const TAGS = [
    "Content Strategy",
    "Organic Growth",
    "Brand Domination",
    "Lead Generation",
    "Sales Optimisation",
];

export default function TrustBar() {
    return (
        <section
            data-testid={TRUST_BAR.root}
            className="relative py-8 md:py-10 overflow-hidden border-y border-[var(--border-subtle)] bg-[rgba(0,0,0,0.25)]"
        >
            <div className="absolute inset-0 opacity-40 pointer-events-none bg-gradient-to-r from-transparent via-[rgba(212,175,55,0.05)] to-transparent" />
            <div className="flex gap-14 md:gap-20 whitespace-nowrap marquee-track">
                {Array(3)
                    .fill(0)
                    .map((_, r) => (
                        <div
                            key={r}
                            className="flex gap-14 md:gap-20 shrink-0 items-center"
                        >
                            {TAGS.map((t, i) => (
                                <div
                                    key={`${r}-${i}`}
                                    className="flex items-center gap-14 md:gap-20 shrink-0"
                                >
                                    <span className="font-display font-semibold text-2xl md:text-4xl lg:text-5xl gold-shimmer tracking-tight">
                                        {t}
                                    </span>
                                    <span className="text-[var(--accent-gold)] text-2xl md:text-3xl">
                                        ✦
                                    </span>
                                </div>
                            ))}
                        </div>
                    ))}
            </div>
        </section>
    );
}
